import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";

import { IBarsortingData, ITaskEditorProps } from "../../../../../../common/types";

import Icon from "../../../../../icon";
import { setItem, hasItem } from "../../../../../cookie";

import Modal from "../../../../Modal";
import { Title, Cancel } from "../../../../Form";

import EditorBar, {
    FlexLeft,
    FlexRight,
    Center,
    Changer,
} from "../../../EditorBar";
import Wrapper from "../../../Wrapper";
import ViewContainer from "../../../ViewContainer";

import ScoreEditor from "./ScoreEditor";
import { IState } from "./interfaces";
import messages from "./messages";
import ChangeColor from "../../Common/ChangeColor";

const Label = styled.div`
    margin-left: 6px;
`;

class BarSortingEditor extends Component<ITaskEditorProps, IState> {
    popup?: HTMLDivElement;
    audioUpload?: HTMLInputElement;
    state: IState = {
        openChanger: undefined,
        playable: false,
        tooBigSize: false,
        audioUploadInProgress: false,
        incorrectType: false,
    };
    changeOpen = (changer: string) => {
        setTimeout(() => {
            if (this.state.openChanger === changer) {
                this.setState({ openChanger: undefined });
                window.removeEventListener("click", this.isClickedOutside);
            } else {
                this.setState({ openChanger: changer });
                setTimeout(() => {
                    window.addEventListener("click", this.isClickedOutside);
                });
            }
        });
    };
    isClickedOutside = (e: MouseEvent) => {
        if (!this.popup!.contains(e.target as Node)) {
            this.setState({ openChanger: undefined });
            window.removeEventListener("click", this.isClickedOutside);
        }
    };
    componentWillUnmount() {
        window.removeEventListener("click", this.isClickedOutside);
    }
    uploadAudioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files!.length === 0) return;
        if (e.target.files![0].size > 1024 * 1024 * 10) {
            this.setState({ tooBigSize: e.target.files![0].size });
            return;
        }
        if (
            e.target.files![0].type !== "audio/mpeg3" &&
            e.target.files![0].type !== "audio/mp3" &&
            e.target.files![0].type !== "audio/mpeg"
        ) {
            this.audioUpload!.value = "";
            return this.setState({ incorrectType: true });
        }
        const { plan, post, editTask, taskIndex } = this.props;
        const data = new FormData();

        data.append("audio", e.target.files![0]);
        data.append("planId", plan._id);
        data.append("index", taskIndex.toString());
        this.setState({ audioUploadInProgress: true });
        post("barsorting-audio-upload", data, res => {
            const { data } = res;
            this.setState({ audioUploadInProgress: false });
            if (data.file) {
                editTask({ taskIndex, changingProp: "audio", val: data.file });
            }
        });
    };
    removeAudio = () => {
        const { post, plan, taskIndex, removeTaskProp } = this.props;
        post("barsorting-delete-audio", { planId: plan._id, index: taskIndex }, () => {
            removeTaskProp!({ taskIndex, removingProp: "audio" });
        });
    };
    setPopupRef = (t: HTMLDivElement) => (this.popup = t)
    render() {
        const { tooBigSize, openChanger, incorrectType, audioUploadInProgress } = this.state;
        const { taskIndex, toggleInlineEditor, plan, publicView, viewProps, inlineEditorOpen, playable } = this.props;
        if (!plan)
            return (
                <div>
                    <FormattedMessage {...messages.loading} />
                </div>
            );
        const data = plan.tasks[taskIndex].data as IBarsortingData;
        const forwardProps = {
            plan,
            taskIndex,
            openChanger,
            handleChangeOpen: this.changeOpen,
            setPopupRef: this.setPopupRef
        }
        return (
            <div>
                {inlineEditorOpen && (
                    <ViewContainer viewProps={viewProps}>
                        <Wrapper>
                            <ScoreEditor taskIndex={taskIndex} plan={plan} />
                        </Wrapper>
                    </ViewContainer>
                )}
                {!publicView && (
                    <EditorBar>
                        <FlexLeft>
                            {data && data.audio ? (
                                <div onClick={this.removeAudio}>
                                    <Changer>
                                        <div>
                                            <Icon i="upload-audio" />{" "}
                                            <Label>
                                                <FormattedMessage {...messages.deleteAudio} />
                                            </Label>
                                        </div>
                                    </Changer>
                                </div>
                            ) : (
                                <div
                                    onClick={() => {
                                        if (!audioUploadInProgress) this.audioUpload!.click();
                                    }}
                                >
                                    <Changer disabled={audioUploadInProgress}>
                                        <div>
                                            <Icon i="upload-audio" />{" "}
                                            <Label>
                                                {audioUploadInProgress ? (
                                                    <FormattedMessage {...messages.uploadAudioInProgress} />
                                                ) : (
                                                    <FormattedMessage {...messages.uploadAudio} />
                                                )}
                                            </Label>
                                        </div>
                                    </Changer>
                                </div>
                            )}
                            <input
                                type="file"
                                accept="audio/mpeg3"
                                style={{ display: "none" }}
                                ref={audioUpload => { this.audioUpload = audioUpload!; }}
                                onChange={this.uploadAudioChange}
                            />
                            {tooBigSize && (
                                <Modal close={() => this.setState({ tooBigSize: false })}>
                                    <Title>
                                        <FormattedMessage {...messages.fileUpload} />
                                    </Title>
                                    <p>
                                        <FormattedMessage {...messages.fileTooLarge} />: {Math.ceil((tooBigSize as number) / 1024)}{" "}
                                        KB
                                    </p>
                                    <p>
                                        <FormattedMessage {...messages.fileSizeLimit} values={{ value: "10" }} />
                                    </p>
                                    <Cancel onClick={() => this.setState({ tooBigSize: false })}>
                                        <FormattedMessage {...messages.close} />
                                    </Cancel>
                                </Modal>
                            )}
                        </FlexLeft>
                        <Center
                            disabled={!playable}
                            onClick={() => {
                                toggleInlineEditor(!inlineEditorOpen);
                                setItem("barSortingDone", "1", 60 * 60 * 24 * 365, "/");
                            }}
                            className={cn(!(inlineEditorOpen && !playable) && !hasItem("barSortingDone") && "pulsate")}
                        >
                            {inlineEditorOpen ? (
                                <FormattedMessage {...messages.stopEdit} />
                            ) : (
                                <FormattedMessage {...messages.cropScore} />
                            )}
                        </Center>
                        <FlexRight>
                            <ChangeColor
                                {...forwardProps}
                                color={data?.color}
                            />
                        </FlexRight>
                    </EditorBar>
                )}
                {incorrectType && (
                    <Modal close={() => this.setState({ incorrectType: false })}>
                        <Title>
                            <FormattedMessage {...messages.fileUpload} />
                        </Title>
                        <p>
                            <FormattedMessage {...messages.fileIncorrectFormat} />
                        </p>
                        <p>
                            <FormattedMessage {...messages.uploadMp3} />
                        </p>
                        <Cancel onClick={() => this.setState({ incorrectType: false })}>
                            <FormattedMessage {...messages.close} />
                        </Cancel>
                    </Modal>
                )}
            </div>
        );
    }
}

export default BarSortingEditor;
